module.exports = __webpack_public_path__ + "static/media/Robot.74162073.png";